import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { api } from 'api';
import { notify } from 'libs/common';
import { Loader2 } from 'libs/ui';
import { ZonesFormForm } from './zones-form-form';

export const ZonesForm = (props) => {
  const { clientId } = props;
  const { t } = useTranslation();
  const [old, setOld] = useState(false);
  const [limits, setLimits] = useState([]);
  const [ready, setReady] = useState(false);
  const [data, setData] = useState({});
  // const rightUpdate = user.haveRight('clients.update');
  // console.log('data', data);

  /**
   * get lk data
   */
  useEffect(() => {
    const getData = () => {
      api.call('clients.get_zones', { client_id: clientId }).then((data) => {
        if (data.zones !== undefined) {
          const limits = data.zones.map((el) => {
            const elOk = { ...el };
            if (!el.id) {
              el.id = el.zone_id;
              el.name = el.zone_id;
            }
            return { ...elOk /*color: colors[el.zone_id]*/ };
          });
          setLimits(limits);
          const out = {
            orders: data.orders,
            validation: data.validation,
            excemption: data.excemption,
            payments: data.payments,
            repayments: data.repayments,
            validate_once: data.validate_once,
            min_validation_limit: data.min_validation_limit ? data.min_validation_limit / 100 : 0,
            validation_limit: data.validation_limit ? data.validation_limit / 100 : 0,
            zones: {},
          };
          limits.forEach((el) => {
            out.zones[el.id] = el.is_zone_visible;
          });
          setOld(false);
          setData(out);
        } else {
          const limits = data.map((el) => {
            return { ...el /*color: colors[el.zone_id]*/ };
          });

          setLimits(limits);
          const out = {};
          limits.forEach((el) => {
            out['zones.' + el.id] = !el.is_zone_visible;
          });
          setOld(true);
          setData(out);
        }

        setReady(true);
      });
    };
    getData();
  }, []);

  /**
   * save lk data
   */
  const save = (data) => {
    const out = { ...data };
    out.zones = Object.keys(data.zones).map((id) => {
      return { id, is_zone_visible: data.zones[id] };
    });
    out.client_id = clientId;
    out.min_validation_limit *= 100;
    out.validation_limit *= 100;
    api
      .call('clients.set_zones', out)
      .then((_data) => {
        notify(t('messages.ВНИМАНИЕ!'), t('messages.Изменения сохранены'), 'success');
      })
      .catch((error) => {
        notify(t('messages.ВНИМАНИЕ!'), error.toString());
      });
  };

  if (!ready) {
    return <Loader2 />;
  }

  return <ZonesFormForm initialValues={data} onSubmit={save} old={old} limits={limits} />;
};
